import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { familyTags } from "@/components/ProductCard";

export const useFamilyFilter = (products) => {
  const [params, setParams] = useSearchParams();
  const families = useMemo(() => {
    const counts = {};
    products.forEach((p) => familyTags(p).forEach((f) => { counts[f] = (counts[f] || 0) + 1; }));
    return Object.entries(counts).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).map(([f]) => f);
  }, [products]);
  const active = useMemo(() => (params.get("family") || "").split(",").filter((f) => families.includes(f)), [params, families]);
  const toggle = (f) => {
    const next = active.includes(f) ? active.filter((x) => x !== f) : [...active, f];
    const p = new URLSearchParams(params);
    if (next.length) p.set("family", next.join(",")); else p.delete("family");
    setParams(p, { replace: true });
  };
  const clear = () => { const p = new URLSearchParams(params); p.delete("family"); setParams(p, { replace: true }); };
  const filtered = active.length ? products.filter((p) => active.some((f) => familyTags(p).includes(f))) : products;
  return { families, active, toggle, clear, filtered };
};

export default function FamilyFilter({ families, active, toggle, clear, total, shown }) {
  if (families.length === 0) return null;
  return (
    <div data-testid="family-filter" className="mb-10">
      <div className="flex items-center justify-between gap-4 mb-3">
        <p className="text-[0.62rem] uppercase tracking-[0.24em] text-black/50">Shop by scent family</p>
        <p className="text-[0.62rem] uppercase tracking-[0.2em] text-black/45" data-testid="family-filter-count">
          {shown} of {total}
          {active.length > 0 && (
            <button type="button" onClick={clear} data-testid="family-filter-clear" className="ml-3 link-line text-[#BA8D53]">Clear</button>
          )}
        </p>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-5 px-5 md:mx-0 md:px-0 md:flex-wrap pb-1">
        {families.map((f) => {
          const on = active.includes(f);
          return (
            <button
              key={f}
              type="button"
              onClick={() => toggle(f)}
              data-testid={`family-chip-${f.toLowerCase()}`}
              aria-pressed={on}
              className={`shrink-0 min-h-[40px] px-4 text-[0.62rem] uppercase tracking-[0.2em] border transition-colors duration-300 ${on ? "bg-[#111] text-[#F7F3EE] border-[#111]" : "border-black/15 text-black/65 hover:border-black"}`}
            >
              {f}
            </button>
          );
        })}
      </div>
    </div>
  );
}
